
import SimpleEvent from './../../zviz2/zviz/event';
import {proxy} from './../../zviz2/zviz/functions';
import {scrollTo} from './../../tools';
import state from './../../zviz2/zviz/state';


class SDG{

    constructor(){

        this.events = [];
        this.svgDoc = null;

        this.element = document.getElementById('sdgBg');
    
        
        for(let i = 1; i <= 17; i++){
            let elm = document.getElementById('img_sdg'+i);
            this.events.push(new SimpleEvent(elm, 'mouseover', [this, this.onMouseOver]));
            this.events.push(new SimpleEvent(elm, 'mouseout', [this, this.onMouseOut]));
            this.events.push(new SimpleEvent(elm, 'click', [this, this.onClick]));
        }    
        


    }

  

    onMouseOver(event){
        let id = event.currentTarget.id.substring(4);
        state.set('tooltip', ['*'+window.sdgTitles[id], window.sdgClickMessage]);
    }

    onMouseOut(event){
        state.set('tooltip', null);
    }

    onClick(event){
        let id = event.currentTarget.id.substring(4);
        let a = document.getElementById(id);
        let elm = a.parentNode;
        let c = scrollTo(elm, 500, true);
        c.start();
    }


    remove(){
        for(let i = 0; i < this.events.length; i++){
            this.events[i].remove();
        }
        this.events = [];
    }

}

export default SDG;